// extracted by mini-css-extract-plugin
module.exports = {"pageNotFound":"style_pageNotFound__JiNIJ","topArticles":"style_topArticles__w4MsB","title":"style_title__73MO5","artwork":"style_artwork__Tdo7w","btn":"style_btn__6qOTt"};